import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Utils from '_utils';
import * as Common from '_common';
import * as Styles from './ProgressBar.module.scss';
export var ProgressDirection;
(function (ProgressDirection) {
    ProgressDirection[ProgressDirection["LeftToRight"] = 0] = "LeftToRight";
    ProgressDirection[ProgressDirection["RightToLeft"] = 1] = "RightToLeft";
    ProgressDirection[ProgressDirection["TopToBottom"] = 2] = "TopToBottom";
    ProgressDirection[ProgressDirection["BottomToTop"] = 3] = "BottomToTop";
})(ProgressDirection || (ProgressDirection = {}));
export var ProgressSize;
(function (ProgressSize) {
    ProgressSize[ProgressSize["Small"] = 0] = "Small";
    ProgressSize[ProgressSize["Normal"] = 1] = "Normal";
    ProgressSize[ProgressSize["Big"] = 2] = "Big";
})(ProgressSize || (ProgressSize = {}));
export var ProgressBarDecoration;
(function (ProgressBarDecoration) {
    ProgressBarDecoration[ProgressBarDecoration["None"] = 0] = "None";
    ProgressBarDecoration[ProgressBarDecoration["Percent"] = 1] = "Percent";
    ProgressBarDecoration[ProgressBarDecoration["Value"] = 2] = "Value";
    ProgressBarDecoration[ProgressBarDecoration["Custom"] = 3] = "Custom";
})(ProgressBarDecoration || (ProgressBarDecoration = {}));
export function RenderProgress(component, index) {
    var value = Number.parseInt(component.properties.value);
    var max = Number.parseInt(component.properties.max);
    var direction = null;
    if (component.properties.direction) {
        var dir = component.properties.direction.toLowerCase();
        if (dir === ProgressDirection[ProgressDirection.LeftToRight].toLowerCase()) {
            direction = ProgressDirection.LeftToRight;
        }
        else if (dir === ProgressDirection[ProgressDirection.RightToLeft].toLowerCase()) {
            direction = ProgressDirection.RightToLeft;
        }
        else if (dir === ProgressDirection[ProgressDirection.TopToBottom].toLowerCase()) {
            direction = ProgressDirection.TopToBottom;
        }
        else if (dir === ProgressDirection[ProgressDirection.BottomToTop].toLowerCase()) {
            direction = ProgressDirection.BottomToTop;
        }
    }
    var size = null;
    if (component.properties.size) {
        var sz = component.properties.size.toLowerCase();
        if (sz === ProgressSize[ProgressSize.Small].toLowerCase()) {
            size = ProgressSize.Small;
        }
        else if (sz === ProgressSize[ProgressSize.Normal].toLowerCase()) {
            size = ProgressSize.Normal;
        }
        else if (sz === ProgressSize[ProgressSize.Big].toLowerCase()) {
            size = ProgressSize.Big;
        }
    }
    var decoration = null;
    if (component.properties.decoration) {
        var dec = component.properties.decoration.toLowerCase();
        if (dec === ProgressBarDecoration[ProgressBarDecoration.Percent].toLowerCase()) {
            decoration = ProgressBarDecoration.Percent;
        }
        else if (dec === ProgressBarDecoration[ProgressBarDecoration.Value].toLowerCase()) {
            decoration = ProgressBarDecoration.Value;
        }
        else if (dec === ProgressBarDecoration[ProgressBarDecoration.Custom].toLowerCase()) {
            decoration = ProgressBarDecoration.Custom;
        }
    }
    return (_jsx(Progress, { value: value, max: max, direction: direction, size: size, decoration: decoration }, index));
}
export function Progress(props) {
    var _a;
    var _b, _c;
    var direction = (_b = props.direction) !== null && _b !== void 0 ? _b : ProgressDirection.LeftToRight;
    var size = (_c = props.size) !== null && _c !== void 0 ? _c : ProgressSize.Normal;
    function getDecoration() {
        if (props.decoration) {
            return props.decoration;
        }
        if (props.customSigns && props.customSigns.length > 0) {
            return ProgressBarDecoration.Custom;
        }
        if (props.valueText) {
            return ProgressBarDecoration.Value;
        }
        if (props.max === 100) {
            return ProgressBarDecoration.Percent;
        }
        return ProgressBarDecoration.None;
    }
    var decoration = getDecoration();
    var style = {
        "--value": (props.value / props.max) * 100 + '%',
    };
    function createSigns() {
        var signs = [];
        function addSign(value, text) {
            var style = { "--value": value + '%' };
            signs.push(_jsx("div", { className: Styles.sign, style: style, children: _jsx("span", { children: text }) }, value));
        }
        console.log('decoration', ProgressBarDecoration[decoration], size);
        if (decoration === ProgressBarDecoration.Percent) {
            if (size === ProgressSize.Normal) {
                for (var i = 25; i <= 75; i += 25) {
                    addSign(i, null);
                }
                addSign(props.value, props.value + '%');
            }
            if (size === ProgressSize.Big) {
                for (var i = 10; i <= 90; i += 10) {
                    addSign(i, i + '%');
                }
            }
        }
        if (decoration === ProgressBarDecoration.Value) {
            if (props.valueText) {
                addSign(50, props.valueText);
            }
            else {
                addSign(50, props.value + '/' + props.max);
            }
        }
        if (decoration === ProgressBarDecoration.Custom && props.customSigns) {
            props.customSigns.forEach(function (sign) {
                var _a;
                addSign(sign.value, (_a = sign.text) !== null && _a !== void 0 ? _a : sign.value.toString());
            });
        }
        return signs;
    }
    var classNames = (_a = {},
        _a[Styles.direction_leftToRight] = direction === ProgressDirection.LeftToRight,
        _a[Styles.direction_rightToLeft] = direction === ProgressDirection.RightToLeft,
        _a[Styles.direction_topToBottom] = direction === ProgressDirection.TopToBottom,
        _a[Styles.direction_bottomToTop] = direction === ProgressDirection.BottomToTop,
        _a[Styles.size_small] = size === ProgressSize.Small,
        _a[Styles.size_normal] = size === ProgressSize.Normal,
        _a[Styles.size_big] = size === ProgressSize.Big,
        _a);
    var signs = createSigns();
    classNames = Common.WithCommonProps(props, classNames);
    function onMouseUp(e) {
        if (props.onClick) {
            var rect = e.currentTarget.getBoundingClientRect();
            var x = e.clientX - rect.left;
            var value = Math.round((x / rect.width) * props.max);
            props.onClick(value);
        }
    }
    return (_jsxs(Common.Component, { name: 'progress', className: Utils.classNames(classNames), onMouseUp: onMouseUp, children: [_jsx("div", { className: Styles.bar, style: style }), signs] }));
}
